import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import type { UpdateVacancyResponsibleRequest, Vacancy } from '../types';
import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { AxiosError } from 'axios';

export const useUpdateVacansyResponsible = (
  id: string
): UseMutationResult<
  Vacancy,
  AxiosError<TFormErrorResponse>,
  UpdateVacancyResponsibleRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_VACANCY_RESPONSIBLE],
    mutationFn: (params: UpdateVacancyResponsibleRequest) =>
      vacancyApi.updateVacansyResponsible(id, params),
  });
};
